import { Container, Box, Typography, useTheme, IconButton, Button, CircularProgress, Divider, Avatar, Chip, Card, CardContent, Grid, Backdrop, Tooltip, LinearProgress, useMediaQuery, Menu, MenuItem } from "@mui/material"
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate, useParams } from "react-router"
import { useOt } from "../../../shared/context/otContext"
import { useEffect } from "react"
import moment from "moment"
import { useUtiles } from "../../../shared/context/utilesContext"
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import PersonIcon from '@mui/icons-material/Person'
import DescriptionIcon from '@mui/icons-material/Description'
import NoteIcon from '@mui/icons-material/Note'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import BuildIcon from '@mui/icons-material/Build'
import OtReviewManager from "../components/DetailOt/OtReviewManager"
import { useTaskContext } from "../../../shared/context/taskContext"
import NextPlanRoundedIcon from '@mui/icons-material/NextPlanRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import iconXls from '../../../assets/xls.png'
import CommentToMoveOt from "../components/DetailOt/CommentToMoveOt"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useAuth } from "../../../shared/context/authContext"
import { useState } from "react"
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import { HistoryOt } from "../components/DetailOt/HistoryOt"
import iconPdf from '../../../assets/pdf.png'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import ChangeAsignedOt from "../components/DetailOt/ChangeAsignedOT"

export default function OTDeatilView() {
    const theme = useTheme()
    const navigate = useNavigate()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const { ot, loadingOt, getOtByHash, setOt, getOtCalculateCompleted, loadingOtCalculateCompleted, otCalculateCompleted, otSelectToMove, setOtSelectToMove, getOtPdf, loadingOtPdf, otPdf } = useOt()
    const { getFirstNameAndLastName, locationString, priorityOptions, openSilderWith, convertHoursToDaysAndHours } = useUtiles()
    const { setHashCodeTask, setTaskByHash, resetResourceSelected, setResourceNotRegister } = useTaskContext()


    //usar reducer para manejar el estado del menu
    const [anchorElMore, setAnchorElMore] = useState(null)
    const openMore = Boolean(anchorElMore)
    const handleCloseMore = () => {
        setAnchorElMore(null)
    }

    //obtener el rol del usuario
    const { authUser } = useAuth();
    const role = authUser ? authUser.role : null;

    const handleToBack = () => {
        navigate('/task/wo')
    }

    const { hash_code } = useParams()

    useEffect(() => {
        //restablecer OTbyHash para evitar que se quede en la misma OT anterior
        setOt(null)
        getOtByHash(hash_code)
        getOtCalculateCompleted(hash_code)
    }, [hash_code])




    const handleOpenReviewManager = (task, ot) => {
        setTaskByHash(null) //necesario para restablecer el taskByHash
        setHashCodeTask({ hash_code: task.hash_code, task_scheduled_id: task?.task_scheduled_id })
        resetResourceSelected()
        setResourceNotRegister(false)
        openSilderWith(<OtReviewManager />, 600, task.description) 
    }


    const renderButtonPass = () => {
        if (ot?.status.name === "in_process") {
            return <Button onClick={() => handleOpenCommentToMoveOt("review", "Pasar a revisión")} startIcon={<NextPlanRoundedIcon sx={{ fontSize: '30px' }} />} variant="contained" color="warning">Pasar a revisión</Button>
        }
        else if (ot?.status.name === "review" && role.can_finish_ot) {
            return <Button onClick={() => handleOpenCommentToMoveOt("completed", "Finalizar revisión")} startIcon={<CheckCircleRoundedIcon sx={{ fontSize: '30px' }} />} variant="contained" color="success">Finalizar revisión</Button>
        }
    }


    const handleOpenCommentToMoveOt = (toStatus, title) => {
        setOtSelectToMove(ot)
        openSilderWith(<CommentToMoveOt title={title} toStatus={toStatus} />, 500, title)
    }

    const handleCancelOt = () => {
        setAnchorElMore(null)
        setOtSelectToMove(ot)
        openSilderWith(<CommentToMoveOt title={'Cancelar OT'} toStatus={'cancel'} />, 500, 'Cancelar OT')
    }

    const handleOpenHistoryOt = () => {
        setAnchorElMore(null)
        openSilderWith(<HistoryOt />, 500, 'Historial de la OT')
    }

    const handleOpenChangeAsignedOt = () => {

        if (ot?.status.name === "in_process") {
            setAnchorElMore(null)
            openSilderWith(<ChangeAsignedOt />, 500, 'Cambiar responsable de la OT')
        }
        
    }

    return (
        <Container maxWidth="xl" sx={{ px: { xs: 0, md: 2 } }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px'
            }}>
                <IconButton
                    onClick={handleToBack}
                    sx={{
                        borderRadius: '12px',
                        padding: '8px',
                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Box>
                    {renderButtonPass()}



                    <Button onClick={(e) => setAnchorElMore(e.currentTarget)} endIcon={<MoreVertRoundedIcon />} variant="contained"
                        sx={{ ml: 2, borderRadius: '10px', backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, '&:hover': { backgroundColor: theme.palette.background.paper } }}>
                        Más
                    </Button>

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorElMore}
                        open={openMore}
                        onClose={handleCloseMore}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        PaperProps={{
                            sx: {
                                mt: 1.5,
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                '&:before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        }}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {
                            ot?.status.name !== "cancel" && ot?.status.name !== "completed" && ot?.status.name !== "review" && (
                                <MenuItem onClick={handleCancelOt}>
                                    <CloseRoundedIcon sx={{ color: theme.palette.error.main, mr: 1 }} />
                                    Cancelar OT</MenuItem>
                            )
                        }

                        <MenuItem onClick={handleOpenHistoryOt} >
                            <HistoryRoundedIcon sx={{ color: theme.palette.primary.main, mr: 1 }} />
                            Ver Historial </MenuItem>
                        <MenuItem onClick={() => getOtPdf(ot.hash_code)}>
                            {loadingOtPdf ? <CircularProgress size={20} sx={{ color: 'warning.main', mr: 1 }} /> : <img src={iconPdf} alt="iconPdf" style={{ width: '20px', height: '20px', marginRight: '10px', color: theme.palette.primary.main }} />}
                            Descargar PDF </MenuItem>
                    </Menu>
                </Box>

            </Box>
            <Box sx={{ p: { xs: 0.5, md: 1 }, borderRadius: '10px', backgroundColor: theme.palette.background.paper, boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)' }}>

                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'left', p: { xs: 0.5, md: 1 } }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '18px', color: theme.palette.text.primary }}>Orden de Trabajo</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'normal', fontSize: '14px', color: theme.palette.text.secondary, mr: 2 }}>Creado el
                            <Chip label={moment(ot?.datetime_created).format('DD/MM/YYYY hh:mm a')} sx={{ borderRadius: '5px', ml: 1, fontWeight: 'bold', lineHeight: '1.5' }} size="small" />
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 'normal', fontSize: '14px', color: theme.palette.text.secondary }}>Creado por
                            <Chip label={getFirstNameAndLastName(ot?.created_by?.fullName)} sx={{ borderRadius: '5px', ml: 1, fontWeight: 'bold', lineHeight: '1.5' }} size="small" />
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ margin: '10px 0', backgroundColor: theme.palette.divider }} />
                <Box sx={{ p: { xs: 0.5, md: 2 }, pb: { xs: 0, md: 2 } }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '12px', color: theme.palette.text.primary, mb: 1 }}>Responble de la tarea</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {ot?.assigned_users.map((user) => (
                            <Box onClick={handleOpenChangeAsignedOt} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', p: 0.5, borderRadius: '5px', "&:hover": { backgroundColor: theme.palette.background.default } }} key={user.id}>
                                <Avatar src={user.avatar} alt={user.fullName} sx={{ width: '30px', height: '30px', marginRight: '10px', background: theme.palette.primary.main }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '16px', color: theme.palette.text.primary }}>{user.fullName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</Typography>
                                <KeyboardArrowDownRoundedIcon sx={{ fontSize: '25px', color: theme.palette.text.primary, ml: 1 }} />
                            </Box>
                        ))}
                    </Box>
                </Box>


                <Box sx={{ p: { xs: 0.5, md: 1 } }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'normal', fontSize: '12px', color: theme.palette.text.primary, mb: 1 }}>Apoyo técnico extra</Typography>
                    {
                        ot?.assigned_extra_users.length > 0 ? (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {ot?.assigned_extra_users.map((user) => (
                                    <Box sx={{ display: 'flex', alignItems: 'center', mr: 2, pr: 1, py: 0.2, borderRadius: '5px', backgroundColor: theme.palette.background.default }} key={user.id}>
                                        <Avatar src={user.avatar} alt={user.fullName} sx={{ width: '25px', height: '25px', marginRight: '5px', background: theme.palette.primary.main, borderRadius: '5px' }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'normal', fontSize: '12px', color: theme.palette.text.primary, fontWeight: 'bold' }}>{getFirstNameAndLastName(user.fullName.toLowerCase()).split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        ) : (
                            <Typography variant="h6" sx={{ fontWeight: 'normal', fontSize: '14px', color: theme.palette.text.secondary }}>No hay apoyo técnico extra</Typography>
                        )
                    }

                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <LinearProgress variant="determinate" value={otCalculateCompleted} />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {`${Math.round(otCalculateCompleted)}%`}
                        </Typography>
                    </Box>
                </Box>


                <Box sx={{ mt: 1, p: { xs: 1, md: 1 }, borderRadius: '16px' }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: theme.palette.text.primary,
                        mb: 3,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <BuildIcon sx={{ color: theme.palette.primary.main, fontSize: '20px' }} />
                        Tareas
                    </Typography>

                    {ot?.tasks?.map((task) => (
                        <Card key={task.id}
                            onClick={() => handleOpenReviewManager(task, ot)}
                            sx={{
                                cursor: 'pointer',
                                backgroundColor: theme.palette.background.default,
                                mb: 2.5,
                                borderRadius: '16px',
                                boxShadow: '0px 4px 20px rgba(0,0,0,0.08)',
                                border: `3px dotted ${theme.palette.divider}`,
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0px 6px 24px rgba(0,0,0,0.12)'
                                },
                                '& .MuiCardContent-root': {
                                    padding: { xs: 1, md: 2 }
                                }
                            }}>
                            <CardContent>
                                {/* Asset Information */}
                                {task.assets?.map((asset) => (
                                    <Box key={asset.id} sx={{
                                        mb: 1,
                                        p: 1,
                                        backgroundColor: theme.palette.background.paper,
                                        borderRadius: '12px',
                                        border: `1px solid ${theme.palette.divider}`,
                                        position: 'relative',
                                        overflow: 'hidden',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '4px',
                                            height: '100%',
                                            backgroundColor: theme.palette.primary.main,
                                            borderRadius: '4px 0 0 4px'
                                        }
                                    }}>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item size={{ xs: 2, md: 1 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Box sx={{
                                                    p: { xs: 1, md: 1.5 },
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.primary.light,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <BuildIcon sx={{ color: "white", fontSize: { xs: 19, md: 28 } }} />
                                                </Box>
                                            </Grid>
                                            <Grid item size={{ xs: 10, md: 11 }}>
                                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0, fontSize: { xs: '13px', md: '16px' } }}>
                                                    Activo: {asset.name}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
                                                    Tipo: {asset.type}
                                                </Typography>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    backgroundColor: theme.palette.background.default,
                                                    p: 0.5,
                                                    borderRadius: '8px',
                                                    width: 'fit-content'
                                                }}>
                                                    <LocationOnIcon sx={{ fontSize: 16, mr: 0.5, color: theme.palette.primary.main }} />
                                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '11px', md: '12px' } }}>
                                                        {locationString(asset.location)}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}

                                {/* Task Details */}
                                <Grid container spacing={1}>
                                    <Grid item size={{ xs: 12 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            mb: 0,
                                            p: 1.5,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`
                                        }}>
                                            <DescriptionIcon sx={{ mr: 1.5, color: theme.palette.primary.main, fontSize: 24 }} />
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: { xs: '12px', md: '14px' } }}>
                                                <span style={{ fontWeight: 'normal' }}>Descripción: </span>
                                                {task.description}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    {task.note && (
                                        <Grid item size={{ xs: 12 }}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                p: 2,
                                                backgroundColor: theme.palette.background.paper,
                                                borderRadius: '12px',
                                                border: `1px solid ${theme.palette.divider}`
                                            }}>
                                                <NoteIcon sx={{ mr: 1.5, mt: 0.5, color: theme.palette.primary.main }} />
                                                <Typography variant="body1" color="text.primary" sx={{ fontSize: { xs: '11px', md: '12px' } }}>
                                                    <span style={{ fontWeight: 'normal' }}>Nota: </span>
                                                    {task.note}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    )}

                                    <Grid item size={{ xs: 12, md: 8 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1.5,
                                            p: 1,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`
                                        }}>
                                            {task.type_task && (
                                                <Chip
                                                    label={`Tipo: ${task.type_task.value}`}
                                                    size="small"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        backgroundColor: theme.palette.primary.light,
                                                        color: "white",
                                                        fontWeight: 'bold'
                                                    }}
                                                />
                                            )}
                                            {task.classification_1 && (
                                                <Chip
                                                    label={`Clasificación 1: ${task.classification_1.value}`}
                                                    size="small"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        backgroundColor: theme.palette.info.light,
                                                        color: "white",
                                                        fontWeight: 'bold'
                                                    }}
                                                />
                                            )}
                                            {task.classification_2 && (
                                                <Chip
                                                    label={`Clasificación 2: ${task.classification_2.value}`}
                                                    size="small"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        backgroundColor: theme.palette.success.light,
                                                        color: "white",
                                                        fontWeight: 'bold'
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Grid>

                                    <Grid item size={{ xs: 12, md: 4 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1.5,
                                            p: 1,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`,
                                            justifyContent: "space-between"
                                        }}>
                                            {task.priority && (
                                                <Chip
                                                    icon={<span style={{ color: priorityOptions.find(p => p.value === task.priority)?.color }}>{priorityOptions.find(p => p.value === task.priority)?.icon}</span>}
                                                    label={`Prioridad: ${task.priority}`}
                                                    size="small"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        backgroundColor: "transparent",
                                                        color: theme.palette.text.primary,
                                                        fontWeight: 'bold'
                                                    }}
                                                />
                                            )}
                                            <Chip
                                                icon={<AccessTimeIcon />}
                                                label={`Duración: ${convertHoursToDaysAndHours(task.time_duration)}`}
                                                size="small"
                                                sx={{
                                                    borderRadius: '8px',
                                                    backgroundColor: "transparent",
                                                    color: theme.palette.text.primary,
                                                    fontWeight: 'bold'
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item size={{ xs: 6, md: 4 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1.5,
                                            p: 1,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`,
                                            justifyContent: "space-between"
                                        }}>
                                            {task.required_ssoma_document ? (
                                                <Chip
                                                    label="Requiere SSOMA"
                                                    size="small"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        backgroundColor: "transparent",
                                                        color: theme.palette.text.primary,
                                                        fontWeight: 'bold'
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label="No requiere SSOMA"
                                                    size="small"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        backgroundColor: "transparent",
                                                        color: theme.palette.text.primary,
                                                        fontWeight: 'bold'
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Grid>

                                    <Grid item size={{ xs: 6, md: 4 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1.5,
                                            p: 1,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`,
                                            justifyContent: "space-between"
                                        }}>
                                            <Typography variant="body1" sx={{ fontSize: '12px', fontWeight: 'bold', color: theme.palette.text.primary }}>
                                                Subtareas: {task.subtasks.length}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item size={{ xs: 12, md: 8 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            p: 1,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`
                                        }}>
                                            <PersonIcon sx={{ mr: 1.5, fontSize: 20, color: theme.palette.primary.main }} />
                                            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '12px' }}>
                                                Solicitado por: <span style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>{task.requested_by}</span>
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item size={{ xs: 12, md: 4 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            p: 1,
                                            backgroundColor: theme.palette.background.paper,
                                            borderRadius: '12px',
                                            border: `1px solid ${theme.palette.divider}`,
                                            justifyContent: { xs: 'flex-start', md: 'flex-end' }

                                        }}>
                                            <CalendarTodayIcon sx={{ mr: 1.5, fontSize: 20, color: theme.palette.primary.main }} />
                                            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '12px' }}>
                                                Inicio estimado: <span style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>{moment(task.datetime_start_estimated).format('DD/MM/YYYY HH:mm')}</span>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            </Box>

            <Backdrop open={loadingOt} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', height: '100%' }}>
                    <Typography variant="h6" sx={{ color: "white", fontWeight: 'bold', fontSize: '18px', mb: 2 }}>Cargando Orden de Trabajo...</Typography>
                    <CircularProgress sx={{ color: "white" }} />
                </Box>
            </Backdrop>
        </Container>
    )
}